import { render, staticRenderFns } from "./AddItemModal.vue?vue&type=template&id=b278bdea&scoped=true&"
import script from "./AddItemModal.vue?vue&type=script&lang=js&"
export * from "./AddItemModal.vue?vue&type=script&lang=js&"
import style0 from "./AddItemModal.vue?vue&type=style&index=0&id=b278bdea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b278bdea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b278bdea')) {
      api.createRecord('b278bdea', component.options)
    } else {
      api.reload('b278bdea', component.options)
    }
    module.hot.accept("./AddItemModal.vue?vue&type=template&id=b278bdea&scoped=true&", function () {
      api.rerender('b278bdea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Inventory/components/AddItemModal.vue"
export default component.exports